import React, { useEffect, useState } from "react";
import styles from "../../../../styles/scope3/Dashboard/purchaseGoods.module.css";
import BarChart from "../../../../Components/GraphNCharts/BarChart";
import LineChart from "../../../../Components/GraphNCharts/LineChart";
import { get } from "../../../../utils/api";
import {
  generateBarChartDataSetForWaste,
  manipulateDataForBarChart,
} from "../../../../utils/graphFunctions";
import EchartDoughnutChart from "../../../../Components/GraphNCharts/EchartDoughnut";
import PeriodFilter from "../../../../Components/Common/PeriodFilter";
import {
  generateMonthArray,
  getMonthCount,
} from "../../../../utils/formatDate";
import {
  fixedTons,
  formatNumberCommaSeparated,
  truncateNumber,
} from "../../../../utils/common";
import { Box, Typography } from "@mui/material";
import NoDataFound from "../../../../Components/Masters/NoDataFound";
import useAuthStore from "../../../../store/ContextUser";

const Dashboard = () => {
  const currentDate = new Date();
  const {selectedCompany}=useAuthStore();
  const currentYear = currentDate.getFullYear();
  const [selectedFacility, setSelectedFacility] = useState([]);
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });
  const [graphView, setGraphView] = useState({
    temporal: "Annual",
  });

  const [dashboardData, setDashboardData] = useState({
    emission: null,
    travelPattern: null,
    duration: null,
    travelMode: null,
    emissionPosition: null,
    temporalAnalysis: null,
    benchmark: null,
  });

  const apiurls = {
    emission: `/dashboard/scope3/business/emission?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    travelPattern: `/dashboard/scope3/business/travel-pattern?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    duration: `/dashboard/scope3/business/duration?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    travelMode: `/dashboard/scope3/business/travel-mode?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    emissionPosition: `/dashboard/scope3/business/emission-position?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    temporalAnalysis: `/dashboard/scope3/business/temporal-analysis?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
    benchmark: `/dashboard/scope3/business/performance-benchmark?startYear=${
      fromDate.year
    }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
      toDate.month
    }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`,
  };

  const fetchData = async () => {
    try {
      const [
        emission,
        travelPattern,
        duration,
        travelMode,
        emissionPosition,
        temporalAnalysis,
        benchmark,
      ] = await Promise.all([
        get(apiurls.emission),
        get(apiurls.travelPattern),
        get(apiurls.duration),
        get(apiurls.travelMode),
        get(apiurls.emissionPosition),
        get(apiurls.temporalAnalysis),
        get(apiurls.benchmark),
      ]);
      setDashboardData({
        emission: emission.data,
        travelPattern: travelPattern.data,
        duration: duration.data,
        travelMode: travelMode.data,
        emissionPosition: emissionPosition.data,
        temporalAnalysis: temporalAnalysis.data,
        benchmark: benchmark.data,
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [fromDate, toDate, selectedFacility,selectedCompany]);

  const generateYearList = (startYear = 2020) => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = startYear; year <= currentYear; year++) {
      years.push(year);
    }
    return years;
  };
  const yearList = generateYearList(2020);

  let barCharDataSet = [
    {
      label: "Industry Benchmarks",
      data: [650, 59, 800, 600, 450, 800, 300, 60, 120],
      backgroundColor: "rgba(255, 187, 51, 0.8)",
      borderColor: "rgba(255, 187, 51, 1)",
      borderWidth: 0.5,
    },
    {
      label: "Our Consumption",
      data: [150, 250, 400, 900, 300, 100, 320, 160, 100, 200, 150, 125],
      backgroundColor: "rgba(0, 102, 231, 0.8)",
      borderColor: "rgba(0, 102, 231, 1)",
      borderWidth: 0.5,
    },
  ];

  console.log(
    dashboardData?.temporalAnalysis?.yearlyData,
    dashboardData?.temporalAnalysis?.monthlyData,
    "d112"
  );

  let yoydataset =
    dashboardData?.temporalAnalysis?.yearlyData
      ?.map((el) => el?.totalTrips)
      ?.filter(Boolean)?.length > 0 ||
    dashboardData?.temporalAnalysis?.yearlyData
      ?.map((el) => el?.totalEmission)
      ?.filter(Boolean)?.length > 0
      ? [
          {
            label: "Travel",
            data: dashboardData?.temporalAnalysis?.yearlyData?.map(
              (item) => item.totalTrips
            ),
            borderColor: "rgba(255, 187, 51, 1)",
            backgroundColor: "rgba(255, 187, 51, 0.6)",
            tension: 0.4,
            fill: true,
            pointBorderColor: "#fff",
            pointRadius: 0,
          },
          {
            label: "Emission",
            data: dashboardData?.temporalAnalysis?.yearlyData?.map(
              (item) => item.totalEmission
            ),
            borderColor: "rgba(0, 102, 231, 1)",
            backgroundColor: "rgba(0, 102, 231, 0.6)",
            tension: 0.4,
            fill: true,
            pointRadius: 0,
          },
        ]
      : [];

  let monthlydataset =
    dashboardData?.temporalAnalysis?.monthlyData
      ?.map((el) => el?.totalTrips)
      ?.filter(Boolean)?.length > 0 ||
    dashboardData?.temporalAnalysis?.monthlyData
      ?.map((el) => el?.totalEmission)
      ?.filter(Boolean)?.length > 0
      ? [
          {
            label: "Travel (Km)",
            data: dashboardData?.temporalAnalysis?.monthlyData?.map(
              (item) => item.totalTrips
            ),
            borderColor: "rgba(255, 187, 51, 1)",
            backgroundColor: "rgba(255, 187, 51, 0.6)",
            tension: 0.4,
            fill: true,
            pointBorderColor: "#fff",
            pointRadius: 0,
          },
          {
            label: "Emission",
            data: dashboardData?.temporalAnalysis?.monthlyData?.map(
              (item) => item.totalEmission
            ),
            borderColor: "rgba(0, 102, 231, 1)",
            backgroundColor: "rgba(0, 102, 231, 0.6)",
            tension: 0.4,
            fill: true,
            pointRadius: 0,
          },
        ]
      : [];

  let businessTravelColor = [
    { label: "Road", color: "rgba(255, 79, 79, 1)" },
    { label: "Rail", color: "rgba(146, 0, 183, 1)" },
    { label: "Air", color: "rgba(14, 98, 224, 1)" },
    { label: "Water", color: "rgba(60, 215, 21, 1)" },
  ];

  let businessTravelDataset = manipulateDataForBarChart({
    data: dashboardData?.emission?.emissionData,
    colors: businessTravelColor,
  });

  let tripDataset =
    dashboardData?.travelPattern?.emissionData
      ?.map((el) => el?.total)
      ?.filter(Boolean)?.length > 0
      ? generateBarChartDataSetForWaste(
          dashboardData?.travelPattern?.emissionData,
          "#0066E7",
          "Trip Frequency"
        )
      : [];

  let travelModeDataset = generateBarChartDataSetForWaste(
    dashboardData?.travelMode?.modeOfTravel,
    "rgba(0, 81, 183, 1)",
    "Trip Frequency"
  );

  let hotelStayCountryDataset = generateBarChartDataSetForWaste(
    dashboardData?.duration?.staysInHotelByCountry,
    "rgba(0, 81, 183, 1)",
    "Days"
  );

  let positionTripDataset = generateBarChartDataSetForWaste(
    dashboardData?.emissionPosition?.travelFrequencyByPosition,
    "rgba(0, 81, 183, 1)",
    "Position"
  );

  const handleGraphChange = (e, type) => {
    if (type === "temporal") {
      setGraphView((prev) => ({ ...prev, temporal: e.target.value }));
    }
  };

  let last10Years = dashboardData?.temporalAnalysis?.yearlyData.map(
    (item) => item.year
  );

  const formatEmissionData = (dataArray, colors) => {
    return dataArray?.map((item, index) => ({
      color: colors[index % colors.length],
      label: item.position,
      value: ((item.totalEmission || item?.total) ?? 0).toFixed(3),
    }));
  };

  const formatTripData = (dataArray, colors) => {
    return dataArray?.map((item, index) => ({
      color: colors[index % colors.length],
      label: item.position,
      value: Math.round(item.totalEmission || item?.total) || 0,
    }));
  };

  const generateDoughnutChartData = (dataArray, colors) => {
    return {
      labels: dataArray?.map((item) => item.position),
      dataPoints: dataArray?.map((item) =>
        ((item.totalEmission || item?.total) ?? 0).toFixed(3)
      ),
      colors: colors.slice(0, dataArray?.length),
    };
  };

  let colorArr = ["#FF4444", "#0066E7", "#FFBB33"];

  let emissionLabels = formatEmissionData(
    dashboardData?.emissionPosition?.emissionByPosition,
    colorArr
  );

  let doughnutChartData = generateDoughnutChartData(
    dashboardData?.emissionPosition?.emissionByPosition,
    colorArr
  );

  let tripsLabels = formatTripData(
    dashboardData?.emissionPosition?.travelFrequencyByPosition,
    colorArr
  );

  let tripsDoughnutChartData = generateDoughnutChartData(
    dashboardData?.emissionPosition?.travelFrequencyByPosition,
    colorArr
  );

  console.log(
    "first",
    dashboardData?.travelPattern?.emissionData
      ?.map((el) => el?.total)
      ?.filter(Boolean)
  );

  return (
    <>
      <div className={styles.heading_container}>
        <p className={styles.heading}>Business Travel</p>
        <PeriodFilter
          {...{
            fromDate,
            setFromDate,
            toDate,
            setToDate,
            yearList,
            setSelectedFacility,
            selectedFacility,
          }}
        />
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Emission Analysis</p>
        <div className={styles.card_container}>
          <p className={styles.graph_heading}>
            Total Emissions from Business Travel (tCO2e)
          </p>
          <p className={styles.card_value}>
            {formatNumberCommaSeparated(
              fixedTons(dashboardData?.emission?.totalEmission ?? 0)
            )}
          </p>
        </div>
        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <div>
              <p className={styles.graph_heading}>
                Emissions by Mode of Travel
              </p>
            </div>
          </div>
          <BarChart
            datasets={businessTravelDataset}
            labels={generateMonthArray(fromDate, toDate)}
            display={true}
          />
        </div>
        {/* <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <p className={styles.graph_heading}>Hotel Stay Emissions</p>
            <p className={styles.graph_value}>200 Days</p>
          </div>
          <BarChart datasets={barCharDataSet} labels={monthSort} />
        </div> */}
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Travel Patterns Analysis</p>

        <div className={styles.emission_container}>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <p className={styles.graph_heading}>Travel Frequency</p>
              <p className={styles.graph_value}>
                {formatNumberCommaSeparated(
                  fixedTons(
                    dashboardData?.travelPattern?.emissionData.reduce(
                      (sum, item) => sum + item.total,
                      0
                    ) / getMonthCount(fromDate, toDate) ?? 0
                  )
                )}{" "}
                trips/month
              </p>
            </div>
            <BarChart
              datasets={tripDataset}
              labels={generateMonthArray(fromDate, toDate)}
            />
          </div>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <p className={styles.graph_heading}>
                Travel by Employee Position (Trips)
              </p>
            </div>
            {dashboardData?.emissionPosition?.travelFrequencyByPosition?.filter(
              Boolean
            )?.length > 0 ? (
              <>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <EchartDoughnutChart
                    labels={tripsDoughnutChartData?.labels}
                    dataPoints={tripsDoughnutChartData?.dataPoints}
                    colors={tripsDoughnutChartData?.colors}
                    customWidth={"150px"}
                    legendPosition="top"
                    hide={true}
                  />
                </div>
                <div className={styles.scope2_table_data}>
                  {tripsLabels?.map((item, index) => (
                    <div key={index} className={styles.table_container}>
                      <div className={styles.table_row}>
                        <span
                          className={styles.table_row_label}
                          style={{
                            backgroundColor: item.color,
                          }}
                        ></span>
                        <span className={styles.table_text}>{item.label}</span>
                      </div>
                      <span className={styles.table_value}>
                        {formatNumberCommaSeparated(
                          fixedTons(item?.value ?? 0)
                        ) + " Trips"}
                      </span>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <NoDataFound mt={"30%"} />
            )}
          </div>
        </div>
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Duration and Stay Analysis</p>
        <div className={styles.card_container}>
          <p className={styles.card_heading}>Avg. Travel Duration (Days)</p>
          <p className={styles.card_value}>
            {formatNumberCommaSeparated(
              fixedTons(
                dashboardData?.duration?.avgDuration[0]?.avgDaysPerTrip ?? 0
              )
            )}
          </p>
        </div>
        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <p className={styles.graph_heading}>Hotel Stay Analysis</p>
            <p className={styles.graph_sub_heading}>
              Number of days stayed at hotels by country
            </p>
          </div>
          <BarChart
            datasets={hotelStayCountryDataset}
            labels={dashboardData?.duration?.staysInHotelByCountry?.map(
              (item) => item.country
            )}
          />
        </div>
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Mode of Travel Analysis</p>
        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <p className={styles.graph_heading}>
              Distribution of buisness travel
            </p>
          </div>
          <BarChart
            datasets={travelModeDataset}
            labels={dashboardData?.travelMode?.modeOfTravel.map((item) => {
              return item.travelMode;
            })}
          />
        </div>
      </div>

      {/* <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Hotel Stays Analysis</p>

        <div className={styles.emission_container}>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <p className={styles.graph_heading}>
                Distribution of hotel stays by class
              </p>
            </div>
            <BarChart datasets={barCharDataSet} labels={monthSort} />
          </div>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <div className={styles.graph_container_header}>
                <p className={styles.graph_heading}>
                  Breakdown of hotel stays by room type
                </p>
              </div>
            </div>
            <BarChart datasets={barCharDataSet} labels={monthSort} />
          </div>
        </div>
      </div> */}

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Employee Position Analysis</p>

        <div className={styles.emission_container}>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <p className={styles.graph_heading}>
                Emissions by Employee Position (tCO2e)
              </p>
            </div>
            {dashboardData?.emissionPosition?.emissionByPosition?.filter(
              Boolean
            )?.length > 0 ? (
              <>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <EchartDoughnutChart
                    labels={doughnutChartData?.labels}
                    dataPoints={doughnutChartData?.dataPoints}
                    colors={doughnutChartData?.colors}
                    customWidth={"180px"}
                    legendPosition="top"
                  />
                </div>
                <div className={styles.scope2_table_data}>
                  {emissionLabels?.map((item, index) => (
                    <div key={index} className={styles.table_container}>
                      <div className={styles.table_row}>
                        <span
                          className={styles.table_row_label}
                          style={{
                            backgroundColor: item.color,
                          }}
                        ></span>
                        <span className={styles.table_text}>{item.label}</span>
                      </div>
                      <span className={styles.table_value}>
                        {formatNumberCommaSeparated(
                          fixedTons(item?.value ?? 0)
                        )}
                      </span>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <NoDataFound mt={"32%"} />
            )}
          </div>
          <div className={styles.card_container}>
            <div className={styles.graph_container_header}>
              <div className={styles.graph_container_header}>
                <p className={styles.graph_heading}>
                  Travel Frequency by Position
                </p>
              </div>
            </div>
            <BarChart
              customHeight={"300px"}
              datasets={positionTripDataset}
              labels={dashboardData?.emissionPosition?.travelFrequencyByPosition?.map(
                (item) => item.position
              )}
            />
          </div>
        </div>
      </div>

      <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>Temporal Analysis</p>
        <div className={styles.chart_container}>
          <div className={styles.temporal_div}>
            <p className={styles.graph_heading}>Year-over-Year Comparison</p>
            <div>
              <select
                name="month"
                id="month"
                value={graphView.temporal}
                onChange={(e) => handleGraphChange(e, "temporal")}
                className={styles.heading_select_month}
              >
                {["Annual", "Year On Year"].map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <LineChart
            dataset={
              graphView?.temporal === "Year On Year"
                ? yoydataset
                : monthlydataset
            }
            labels={
              graphView?.temporal === "Year On Year"
                ? last10Years
                : generateMonthArray(fromDate, toDate)
            }
            display={true}
          />
        </div>
      </div>

      {/* <div className={styles.purchase_container}>
        <p className={styles.sub_heading}>
          Comparative and Benchmarking Analysis
        </p>
        <div className={styles.chart_container}>
          <div className={styles.graph_container_header}>
            <p className={styles.graph_heading}>Comparison of Travel Modes</p>
          </div>
          <BarChart
            datasets={comparativeTravelDataset}
            labels={monthSort}
            display={true}
          />
        </div>
      </div> */}
    </>
  );
};

export default Dashboard;
